export default "__VITE_ASSET__6a515c63__"